import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '~environment';

@Injectable({
  providedIn: 'root'
})
export class ContactoService {
  private readonly triidyServiceUrl = `${environment.apiTriidyUrl}`;
  private readonly triidyServiceUrlRest = `${environment.apiTriidyUrlRest}/api`;

  constructor(private http: HttpClient) { }

  enviarMail(DatosUser: any): Observable<any[]> {
    const token = environment.serviceToken;
    DatosUser.token = token;

    //console.log(DatosUser);

    return this.http
      .post<any>(`${this.triidyServiceUrlRest}/Leads`, DatosUser)
      .pipe(
        map((respuesta) => {
          //console.log(respuesta);
          return respuesta;
        }, (err) => {
          //console.log(err);
        })
      );
  }

}
